export default {
      id: "tag-usage",
      viewBox: "0 0 13 16",
      url: "/assets/" + "icons.svg#tag",
      toString: function () {
        return this.url;
      }
    }